import React from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  Col,
  Row,
  Modal,
  Button,
  Form,
  Steps,
  // message,
  Input,
  Result,
  Select,
  Spin
} from "antd";
import RegistrationTypeSelect from "../../../common/components/registration-type-select";
import ConfirmationCodeSelect from "../components/confirmation-code-tour-select";
import { MinimumDataForm, LiteMinimumDataForm } from '../../registeration/form';
// import regAction from "../actions";
// import registrationAction from '../../../features/registeration/actions';
import { phoneNumberCountryCodes, getCountryCallingCode, phoneNumberFormatter } from "../../../common/utils/phone-number-helper";
import { IsLiteVersion, IsFullVersion } from "../../../common/utils/system-version-helper";

const { Step } = Steps;

class LiteRegistrationModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.props.handleCancel;
    this.handleOk = this.props.handleOk;
    this.state = {
      current: 0,
      RegistrationTypeId: 1,
      ConsumerId: 1,
      CountryCode: "UK (+44)",
      Id: null,
      PhoneNumber: "55555555555",
      RegistrationId: null,
    };
  }  

  onOk = () => {
    this.setState((prevState) => ({
      ...prevState,
      current: 0,
      RegistrationTypeId: 1,
      CountryCode: "",
      Id: null,
      PhoneNumber: "",
    }));
    this.props.handleOk();
  };

  canCloseModal = () => {
    this.props.handleCancel();
  }

  onModalClose = () => {
    if(this.state.current === 3){
      this.onOk();
    }
    this.setState({
        current: 0,
        RegistrationTypeId: 1,
        ConsumerId: null,
        CountryCode: "",
        Id: null,
        PhoneNumber: null,
        RegistrationId: null,
    })
  }

  editVictimData = () => {
    this.props.dispatch(push(`/register/${this.props.dataId}/edit`));
  };

  handleChange = (data) => {
    const { value, id } = data.target;
    this.setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  newRegistrationCallback = (RegistrationId) => {
    this.setState((prevState) => ({
      ...prevState,
      RegistrationId,
    }));

    this.next();
  }

  

  tourRegStep = () => {
    if(this.state.current !== 0)
      this.setTourStep(0);
  }

  tourMinStep = () => {
    if(this.state.current !== 1)
      this.setTourStep(1);
  }

  tourCompleteStep = () => {
    if(this.state.current !== 2)
      this.setTourStep(2);
  }

  setTourStep = (step) => {
    this.setState((prevState) => ({
      ...prevState,
      current: step,
    }));
  }

  newRegistrationErrorCallback = (response) => {
    const WarnConfig = {
      Title: 'Unable to Complete Registration',
      content: (
        <>
          <div>
            <span>
              Unable to complete registration
            </span>
            <br />
            <br />
            <span>
              {`${response}`}
            </span>
          </div>
        </>
      )
    };

    const { warning } = Modal;
    warning(WarnConfig);
  }

  AddMinData = (data) => {
    console.log('add min data', data);
    // this.props.dispatch(registrationAction.AddMinData(data, this.handlAddMinCallback));
  };

  handlAddMinCallback = () => {
    this.next();
  }

  next() {
    const current = this.state.current + 1;
    this.setState((prevState) => ({
      ...prevState,
      current,
    }));
  }

  CreateNewRegistration(vals) {
    console.log('new vals', vals);

    this.newRegistrationCallback();
  }

  prev() {
    const current = this.state.current - 1;
    this.setState((prevState) => ({
      ...prevState,
      current,
    }));
  }

  render() {
    const { current } = this.state;

    const steps = [
      {
        title: "New Registration",
      },
      {
        title: "Victim Data",
      },
      {
        title: "Complete",
      },
    ];

    return (
      <>
        <Modal
          width={650}
          visible={this.props.isVisible}
          onOk={this.props.handleOk}
          onCancel={this.canCloseModal}
          afterClose={this.onModalClose}
          footer={false}
          // closable={steps[current].title !== "Victim Data"}
          destroyOnClose
        >
          <div className="mb-3">
            <Steps current={current}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            <Button id="sh-reg-min-save-btn" style={{display: "None"}} onClick={this.handlAddMinCallback} />
            <Button id="sh-add-new-reg-step" style={{display: "None"}} onClick={this.tourRegStep} />
            <Button id="sh-add-new-reg-min-step" style={{display: "None"}} onClick={this.tourMinStep} />
            <Button id="sh-add-new-reg-complete-step" style={{display: "None"}} onClick={this.tourCompleteStep} />
          </div>
          <Formik
            enableReinitialize
            initialValues={{
              RegistrationTypeId: this.state.RegistrationTypeId,
              Id: this.state.Id,
              ConsumerId: this.state.ConsumerId,
              PhoneNumber: this.state.PhoneNumber,
              CountryCode: this.state.CountryCode,
            }}
            validationSchema={Yup.object().shape({
              RegistrationTypeId: Yup.string()
                .typeError("Registration Type is required")
                .required("Registration Type is required"),
              CountryCode: Yup.string()
                .typeError("Country Code is required")
                .required("Country Code is required"),
              PhoneNumber: Yup.string()
                .typeError("Phone Number is required")
                .required("Phone Number is required")
                .matches(/^[1-9].*$/, 'Phone number cannot begin with a 0'),
              // ConsumerId: Yup.number()
              //   .typeError("Confirmation Code is required")
              //   .required("Confirmation Code is required")
            })}
            onSubmit={(values) => {
              this.CreateNewRegistration(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              setFieldValue,
              handleChange,
              handleSubmit,
              handleBlur
            }) => (
              <Form
                id="registerForm"
                name="registerForm"
                onSubmit={handleSubmit}
                onChange={handleChange}
                autoComplete={0}
              > 
                {steps[current].title === "New Registration" && (
                  <>
                    <Row gutter={[16, 32]}>
                      <Col span={12}>
                        <Form.Item
                          validateStatus={
                            errors &&
                                errors.RegistrationTypeId &&
                                touched.RegistrationTypeId
                                ? "error"
                                : null
                            }
                          help={
                            errors &&
                            touched.RegistrationTypeId &&
                            errors.RegistrationTypeId
                            }
                        >
                          <div className="form-label"> Registration Type: </div>
                          <RegistrationTypeSelect
                            key={values.RegistrationTypeId}
                            value={values.RegistrationTypeId}
                            isNewRegister
                            onChange={(val) => {
                                setFieldValue("RegistrationTypeId", val);
                                this.setState({ RegistrationTypeId: val });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {
                        values.RegistrationTypeId === 1 && (
                          <Col xs={24} sm={24} md={12} lg={12}>
                            <Form.Item
                              validateStatus={
                                errors && errors.ConsumerId && touched.ConsumerId
                                  ? "error"
                                  : "success"
                              }
                              help={
                                errors && touched.ConsumerId && errors.ConsumerId 
                                  ? errors.ConsumerId
                                  : null
                              }
                            >
                              <div className="form-label"> Confirmation Code: </div>
                              <ConfirmationCodeSelect
                                className="p5-form-dropdown sh-tour-confirm-code"
                                name="ConsumerId"
                                value={values.ConsumerId}
                                onChange={(val) => {
                                  setFieldValue("ConsumerId", val);
                                }}
                              />
                            </Form.Item>
                          </Col>
                        )
                      }
                    </Row>
                    <Row gutter={[16, 32]}>
                      <Col span={12}>
                        <Form.Item
                          validateStatus={
                            errors && errors.CountryCode && touched.CountryCode
                              ? "error"
                              : null
                          }
                          help={
                            errors && touched.CountryCode && errors.CountryCode
                          }
                        >
                          <div className="form-label"> Country Code: </div>
                          <Select
                            id="test-cc"
                            className="sh-tour-country-code-select"
                            showSearch
                            placeholder="Ex. US (+1)"
                            onChange={(val) => setFieldValue("CountryCode", val)}
                            onBlur={handleBlur}
                            value={values.CountryCode}
                          >
                            {phoneNumberCountryCodes
                              .map((code) => (
                                <Select.Option value={code} key={code}>
                                  {code} (+{getCountryCallingCode(code)})
                                </Select.Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          validateStatus={
                            errors && errors.PhoneNumber && touched.PhoneNumber
                              ? "error"
                              : "success"
                          }
                          help={
                            errors && touched.PhoneNumber && errors.PhoneNumber 
                              ? errors.PhoneNumber
                              : null
                          }
                        >
                          <div className="form-label"> Phone Number:</div>
                          <Input
                            type="text"
                            id="PhoneNumber"
                            className="sh-tour-phone-number-cli"
                            name="PhoneNumber"
                            value={phoneNumberFormatter(values.PhoneNumber)}
                            placeholder="Phone #"
                            onChange={(val) => {
                              setFieldValue("PhoneNumber", val.replace(/[^\d]/g, ""));
                            }}
                            onBlur={handleBlur}
                            autoComplete="off"
                          />
                        </Form.Item>
                      </Col>                      
                    </Row>
                  </>
                )}

                {steps[current].title === "Complete" && (
                  <>
                    <Row justify="center">
                      <Col span={24}>
                        {this.state.loading ? 
                          <Spin size="large" /> :
                          <Result status="success" title="Registration Complete" />}
                      </Col>
                    </Row>
                  </>
                )}
                <div className="steps-content">{steps[current].content}</div>
                <div className="steps-action">                  
                  {steps[current].title === "New Registration" && (
                    <>
                      <span>
                        <Button
                          type="primary"
                          //   onClick={handleSubmit}
                          className="sh-tour-add-new-reg-btn"
                          disabled={errors && (errors.CountryCode || errors.PhoneNumber) || values.RegistrationTypeId === 1 && values.ConsumerId === null}
                          loading={this.props.loading}
                        >
                          Add New Registration
                        </Button>
                      </span>
                      <span><Button id="sh-add-new-reg-btn" style={{display: "None"}} onClick={handleSubmit} /></span>
                    </>
                  )}
                  {current === steps.length - 1 &&
                    IsLiteVersion() && (
                    <Button
                      type="primary"
                      onClick={this.onOk}
                      loading={this.props.loading}
                    >
                      Complete
                    </Button>
                  )}
                  {current === steps.length - 1 &&
                    IsFullVersion() && (
                    <span className="sh-tour-reg-min-complete-btns" style={{ padding: "10px 0px" }}>
                      <Button
                        style={{ margin: "0 8px" }}
                        //   onClick={() => this.editVictimData()}
                        loading={this.state.loading}
                      >
                        Complete Now
                      </Button>
                      <Button
                        type="primary"
                        //   onClick={this.onOk}
                        loading={this.props.loading}
                      >
                        Complete Later
                      </Button>
                    </span>
                  )}
                </div>
              </Form>
              )}
          </Formik>
          {current < steps.length - 1 &&
            IsFullVersion() &&
            steps[current].title === "Victim Data" && (
              <div>
                <MinimumDataForm Id={this.state.RegistrationId} isLoading={this.props.minDataLoading} onSubmit={this.AddMinData} showClose onCancel={() => this.canCloseModal} isTour />
              </div>
            )}  
          {current < steps.length - 1 &&
            IsLiteVersion() &&
            steps[current].title === "Victim Data" && (
              <div>
                <LiteMinimumDataForm Id={this.state.RegistrationId} isLoading={this.props.minDataLoading} onSubmit={this.AddMinData} showClose onCancel={() => this.canCloseModal} isTour />
              </div>
            )}  
        </Modal>
      </>
    );
  }
}

LiteRegistrationModal.propTypes = {
  // onSubmit: PropTypes.func.isRequired,
  dispatch: () => { },
  isVisible: PropTypes.bool,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  dataId: PropTypes.number,
  loading: PropTypes.bool,
  minDataLoading: PropTypes.bool,
};

LiteRegistrationModal.defaultProps = {
  dispatch: () => { },
  isVisible: false,
  handleOk: () => { },
  handleCancel: () => { },
  dataId: 0,
  loading: false,
  minDataLoading: false,
};

function mapStateToProps(state) {
  const { dataId, loading } = state.RegistrationModal;

  const minDataLoading = state.RegisterUserFormState.loading;
  return {
    dataId,
    loading,
    minDataLoading,
  };
}

const connectedLiteRegistrationModal = connect(mapStateToProps)(LiteRegistrationModal);

export { connectedLiteRegistrationModal as default };
